import { render, staticRenderFns } from "./MyTransfer.vue?vue&type=template&id=591bbba3&scoped=true&"
import script from "./MyTransfer.vue?vue&type=script&lang=js&"
export * from "./MyTransfer.vue?vue&type=script&lang=js&"
import style0 from "./MyTransfer.vue?vue&type=style&index=0&id=591bbba3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bbba3",
  null
  
)

export default component.exports